export default {"src":"/_next/static/media/error_icon.70f1c5f2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};